import React from 'react';

export interface DetailHeaderContextProps {
  showInfo: boolean,
  scrolled: number,
  setShowInfo: Function
}

const DetailHeaderContext = React.createContext<Partial<DetailHeaderContextProps>>({
  showInfo: false,
  scrolled: 0,
  setShowInfo: () => {}
});

export default DetailHeaderContext;
